import Link from 'next/link';
import styled from 'styled-components';
import { Image } from 'shared/components/Image';

import { IConstructorResult } from 'shared/types/ConstructorResult';
import { variableFontRegular } from 'styles/theme/text';

export interface IWindowItemProductProps {
  product: IConstructorResult;
}

export const WindowItemProduct = ({ product }: IWindowItemProductProps) => {
  const { data, value: name } = product;
  const { image_url: imageUrl, category, slug } = data;

  return (
    <Link href={`/${category === 'shoes' ? 'sneakers' : 'apparel'}/${slug}`} passHref>
      <WindowItemProduct.Wrapper>
        <WindowItemProduct.Img>
          <Image
            alt={name}
            data-qa="window_item_product_image"
            disableLazyLoad
            sizes="20vw"
            src={imageUrl}
          />
        </WindowItemProduct.Img>
        <WindowItemProduct.Name data-qa="window_item_product_name">{name}</WindowItemProduct.Name>
      </WindowItemProduct.Wrapper>
    </Link>
  );
};

WindowItemProduct.Wrapper = styled.a`
  border-bottom: ${({ theme }) => theme.borders.black};
  cursor: pointer;
  display: flex;
  flex-direction: row;
  padding: 8px 16px;

  :hover {
    text-decoration: underline;
  }
`;

WindowItemProduct.Img = styled.div`
  height: 56px;
  width: 56px;
  margin-right: 16px;
`;

WindowItemProduct.Name = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 16px;

  @media (max-width: ${({ theme }) => theme.breakpoints.small - 1}px) {
    ${variableFontRegular({ height: '14px', size: '11.5px' })}
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.small}px) {
    ${variableFontRegular({ height: '14px', size: '11.5px' })}
  }
`;
